import styled from 'styled-components'

interface IBudgetCategoryAttributeDescriptionsStyledProps {}

export const BudgetCategoryAttributeDescriptionsStyled = styled.div<IBudgetCategoryAttributeDescriptionsStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  .attribute-wrapper {
    white-space: pre;
  }
`
